module.exports = (__parcel__import__("4tDRU")).then(() => parcelRequire('g36Vt'));